const { REACT_APP_ENVIRONMENT, REACT_APP_BASE_URL } = process.env
export const CONFIG = {
    ENVIRONMENT: REACT_APP_ENVIRONMENT,
    BASE_URL: REACT_APP_BASE_URL,
}
export const API_REQ_TYPE = {
    GET: 'get',
    POST: 'post',
    PATCH: 'patch',
    PUT: 'put',
    DELETE: 'delete',
}

export const API_RESPONSE_CODES = {
    SUCCESS: 200,
    SUCCESS_CREATE: 201,
    SUCCESS_ACCEPTED: 202,
    SUCCESS_NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORISED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    PAYLOAD_ERROR: 502,
}

export const TOKEN_KEY = 'accessToken'
